module.exports = __webpack_public_path__ + "static/media/artist-rush-album-11.00293baa.jpg";